<div style="padding: 0;">
    <div class="panel-group">
        <div class="panel" [class.company-panel]="company.Active" [class.panel-warning1]="!company.Active">
            <!--Live Companies-->
            <ng-container *ngIf="live">
                <div class="panel-heading">
                    <h5 style="display: inline-block">
                        <img alt="logo" width="25" height="25" src="api/Manuals/CompanyLogo?companyId={{ company.Id }}&_ts={{ modified }}" />
                        <span [ngClass]="textColor">{{ label }}</span>
                    </h5>
                    <div class="pull-right btn-toolbar">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-info" title="Expand Company" (click)="getMinesites()">
                                <span data-toggle="tooltip" class="fa fa-lg fa-chevron-down" [class.fa-chevron-down]="!minesitesVisible" [class.fa-chevron-up]="minesitesVisible"></span>
                            </button>
                            <button type="button" class="btn btn-info" title="Company Details" (click)="showDetails()">
                                <span data-toggle="tooltip" class="fa fa-list-alt fa-lg"></span>
                            </button>
                        </div>
                        <div class="btn-group btn-group-sm" *ngIf="!live">
                            <button type="button" class="btn btn-info" title="Edit Company" (click)="edit()">
                                <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                            </button>
                            <button type="button" class="btn btn-info" title="Remove Company" (click)="deleteCompany()">
                                <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                            </button>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ng-container>
            <!--End Live Companies-->
            <!--Staging Companies-->
            <ng-container *ngIf="!live">
                <div [class.panel-heading]="company.Status==0" [class.panel-Staged]="(company.Status==1 || company.Status==2)" [class.panel-warning1]="company.Status==4" [attr.data-company-id]="company.Id" cdkDropList [cdkDropListData]="minesites" (cdkDropListDropped)="cdkDropEventTriggered($event)">
                    <h5 style="display: inline-block;color:white">
                        <img alt="logo" width="25" height="25" src="api/Manuals/CompanyLogo?companyId={{ company.Id }}&_ts={{ modified }}" />
                        <span [ngClass]="textColor">
                            {{ label }}
                        </span>
                    </h5>
                    <div class="pull-right btn-toolbar">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-info" title="Expand Company" (click)="getMinesites()">
                                <span data-toggle="tooltip" class="fa fa-lg fa-chevron-down" [class.fa-chevron-down]="!minesitesVisible" [class.fa-chevron-up]="minesitesVisible"></span>
                            </button>
                            <button type="button" class="btn btn-info" title="Company Details" (click)="showDetails()">
                                <span data-toggle="tooltip" class="fa fa-list-alt fa-lg"></span>
                            </button>
                        </div>
                        <ng-container>
                            <div class="btn-group btn-group-sm" *ngIf="!live">
                                <button type="button" class="btn btn-info" title="Edit Company" (click)="edit()">
                                    <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                                </button>
                                <button type="button" class="btn btn-info" title="Remove Company" (click)="deleteCompany()">
                                    <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ng-container>
            <!--End Staging Companies-->

            <div class="panel-collapse collapse" [class.in]="minesitesVisible">
                <div class="panel-body" *ngIf="minesitesVisible">
                    <minesite-entity [live]="live" [companyId]="company.Id" [minesite]="minesite" [simplified]="true" *ngFor="let minesite of minesites"></minesite-entity>
                </div>
            </div>
        </div>
    </div>
</div>
<div bsModal #DeleteCompany="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Delete Company
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Delete this Company:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="DeleteSelectedCompany()">Confirm Delete</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>